import { render, staticRenderFns } from "./ResizeHandle.vue?vue&type=template&id=0865ba0f&scoped=true"
import script from "./ResizeHandle.vue?vue&type=script&lang=js"
export * from "./ResizeHandle.vue?vue&type=script&lang=js"
import style0 from "./ResizeHandle.vue?vue&type=style&index=0&id=0865ba0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865ba0f",
  null
  
)

export default component.exports